import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import ThingsToDo from "./pages/ThingsToDo";
import WhatToEat from "./pages/WhatToEat";

import Gallery from "./pages/Gallery";

import "./App.css";

function App() {
	return (
		<Router>
			<div>
				<Routes>
					<Route
						path="/"
						element={<Home />}
					/>
					<Route
						path="/about"
						element={<About />}
					/>
					<Route
						path="/things-to-do"
						element={<ThingsToDo />}
					/>
					<Route
						path="/what-to-eat"
						element={<WhatToEat />}
					/>
					<Route
						path="/gallery"
						element={<Gallery />}
					/>
				</Routes>
			</div>
		</Router>
	);
}

export default App;
